import { getRandomBetween } from "../utils";

export default function createRoskQueen() {
  const pattern = getRandomBetween(0.8, 0.99);

  const layingVigor = getRandomBetween(0.2, 0.5);
  const honey = getRandomBetween(0.2, 0.7);
  const diseaseResistance = getRandomBetween(0.6, 0.9);
  const swarmTendency = getRandomBetween(0.5, 0.99);
  const aggression = getRandomBetween(0.7, 0.99);
  const miteResistance = getRandomBetween(0.5, 0.8);
  const overWinter = getRandomBetween(0.8, 0.99);

  let queenStats = {
    haveQueen: true,
    layingVigor: layingVigor,
    pattern: pattern,
    honey: honey,
    diseaseResistance: diseaseResistance,
    swarmTendency: swarmTendency,
    droneTendency: 0.05,
    aggression: aggression,
    virgin: false,
    laying: true,
    miteResistance: miteResistance,
    overwinter: overWinter,
    breed: "Rosk",
    birth: new Date().getTime(),
  };
  return queenStats;
}
